(function($){
    $.fn.addAccess = function(options){
      var settings = $.extend({
        //default settings
        role: 'button',
        tabindex: '0'
      }, options);
      
      $(this).attr('tabindex', settings.tabindex).attr('role', settings.role).on('keyup.access', function(e){
        var keyCode = e.which;
        if ((keyCode === 13) || (keyCode === 32)){
          $(this).click();
        }
      });
  
      return(this);
    };
    
    $.fn.removeAccess = function(){
        $(this).removeAttr('tabindex').removeAttr('role').off('keyup.access');
        return(this);
    };
})($JQ);